import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-xitonggaishu",
  "use": "icon-xitonggaishu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xitonggaishu\"><path d=\"M128 170.682182h768V256H128V170.682182z m0 298.635636h768v85.317818H128v-85.317818z m0 298.682182h768v85.317818H128V768z\" p-id=\"4243\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol